import {LineupStackCombinationsMapInterface} from './interfaces/lineup-stack-combinations-map.interface';

export function createLineupKeyPlayerStackCombinationsMap(comboGroups): LineupStackCombinationsMapInterface {
    const map: LineupStackCombinationsMapInterface = {
        lineups: {},
        combinations: {},
    };

    comboGroups.map((group) => {
        group.sortedCombos.map((combo) => {
            const combinationId = combo.getUnitId();

            !(combinationId in map.combinations) && (map.combinations[combinationId] = {});

            combo.getLineupIds().map((lineupId) => {
                !(lineupId in map.lineups) && (map.lineups[lineupId] = {});
                map.lineups[lineupId][combinationId] = true;
                map.combinations[combinationId][lineupId] = true;
            });
        });
    });

    return map;
}
